import Vue from 'vue'

import * as VueGoogleMaps from '@/node_modules/vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: { key: 'AIzaSyD0j4TouTU3iXaRSmup4Q7EvflLb-ELhSI' },
})
